//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prePickCreate', {
//        templateUrl: 'views/components/views/prePickCreate/prePickCreate.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'prePickCreateService', function ($stateParams, stateService, translateService, modalService, prePickCreateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
//            let setting = {};

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                itemsListPrePick: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                setting = (await prePickCreateService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }
    		
//            async function loadPrePick() {
//                return vm.model.itemsListPrePick = await prePickCreateService.listPrePick(setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region SAVE TO PREVIOUS PROCEDURE FUNCTION CALL

//            vm.goToPrevious = function (item) {
//                prePickCreateService.saveToPrevious({
//                    argtype: argType,
//                    argvalue: argValue,
//                    stocklocation_keyno: item.item_id
//                }).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion SAVE TO PREVIOUS PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadPrePick();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
